import { Link } from "@tanstack/react-router";
import { ArrowRight, GitBranch, Handshake, ShoppingCart, Ticket, Users } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const syncTypes = [
  {
    to: "/data-sync/deals",
    label: "Deals",
    description: "Mirror HubSpot deals to local database",
    icon: Handshake,
  },
  {
    to: "/data-sync/pipelines",
    label: "Pipelines",
    description: "Mirror HubSpot deal pipelines and stages",
    icon: GitBranch,
  },
  {
    to: "/data-sync/owners",
    label: "Owners",
    description: "Mirror HubSpot owners locally",
    icon: Users,
  },
  {
    to: "/data-sync/shopify-orders",
    label: "Shopify Orders",
    description: "Mirror Shopify orders and line items locally",
    icon: ShoppingCart,
  },
  {
    to: "/data-sync/tickets",
    label: "Tickets",
    description: "Mirror HubSpot tickets (repairs, returns, service) locally",
    icon: Ticket,
  },
] as const;

export function DataSyncPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Data Sync"
        description="Configure automated data feeds and data mirroring"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {syncTypes.map((sync) => (
          <Link key={sync.to} to={sync.to} className="group">
            <Card className="transition-colors hover:border-brand-gold/40 hover:shadow-sm">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">{sync.label}</CardTitle>
                <sync.icon className="h-4 w-4 text-muted-foreground" />
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">{sync.description}</p>
                <div className="mt-3 flex items-center gap-1 text-xs font-medium text-brand-gold opacity-0 transition-opacity group-hover:opacity-100">
                  Configure
                  <ArrowRight className="h-3 w-3" />
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
